module.exports = __webpack_public_path__ + "a66568864b63ea6e584e04089e0457ac.png";